export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-lg p-8 md:p-12 border border-background-200/70">
          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative w-full max-w-sm aspect-[3/2] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20mobile%20reading%20app%20mockup%20featuring%20smartphone%20displaying%20colorful%20comic%20page%20warm%20ambient%20lighting%20modern%20app%20interface%20design%20clean%20professional%20presentation%20on%20wooden%20desk%20with%20warm%20atmosphere&width=900&height=600&seq=app-kr-01&orientation=landscape"
                alt="韩漫移动端阅读 - 手机看韩漫"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col items-start gap-4">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              移动端阅读
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              韩漫平台已全面适配手机与平板浏览器访问。无需下载任何App，打开浏览器即可享受流畅的竖屏阅读体验。智能分页、自适应缩放、夜间模式等贴心功能，让你的移动端<strong>韩漫在线免费阅读</strong>更加舒适。
            </p>

            <div className="flex items-center gap-4 flex-wrap">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-smartphone-line text-lg"></i>
                </div>
                <span>手机适配</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-tablet-line text-lg"></i>
                </div>
                <span>平板适配</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-moon-line text-lg"></i>
                </div>
                <span>夜间模式</span>
              </div>
            </div>

            <a
              href="#cards"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer mt-2"
            >
              <i className="ri-book-open-line text-lg"></i>
              立即体验
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}